import { render, staticRenderFns } from "./CardSection.vue?vue&type=template&id=64893624&scoped=true"
import script from "./CardSection.vue?vue&type=script&lang=js"
export * from "./CardSection.vue?vue&type=script&lang=js"
import style0 from "./CardSection.vue?vue&type=style&index=0&id=64893624&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64893624",
  null
  
)

export default component.exports